import { Component, OnInit, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RetestService } from 'app/services/retest-service';
import { HouseholdService } from 'app/services/household-service';
import { VoucherService } from 'app/services/voucher-service';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';
import { FormControl, FormGroup } from '@angular/forms';
import { RetestBulkOperation } from 'app/models/retest/retest';
import { SharedService } from '@shared/services/shared.service';

/*
 * bulk Retest Dialog
 */
@Component({
  selector: 'dialog-retests-bulk',
  templateUrl: 'retests-bulk-dialog.html',
  styleUrls: ['./retests-bulk-dialog.scss']
})
export class DialogBulkOperationRetestsComponent implements OnInit {

  processing: boolean = false;
  bulkForm = new FormGroup({
      operation: new FormControl(''),
      status: new FormControl(''),
      year: new FormControl(0),
      quarter: new FormControl(0),
      tier: new FormControl(0),
      dueBy: new FormControl()
  });
  bulkOperation: RetestBulkOperation = {
    ids: [],
    operation: '',
    status: '',
    year: 0,
    quarter: 0,
    tier: 0,
    dueBy: ''
  };


  constructor(public retestService: RetestService, private toastr: ToastrService,
    public sharedService: SharedService,
     public dialog: MatDialog, public authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: RetestBulkOperation, private dialogRef: MatDialogRef<DialogBulkOperationRetestsComponent>) {
    this.bulkOperation = data;
  }

  ngOnInit(): void {
    this.setFormValues();
  }

  load() {
  }



  getFormValues() {
    this.bulkOperation.operation = this.bulkForm.get('operation').value;
    this.bulkOperation.status = this.bulkForm.get('status').value;
    this.bulkOperation.year = this.bulkForm.get('year').value;
    this.bulkOperation.quarter = this.bulkForm.get('quarter').value;
    this.bulkOperation.tier = this.bulkForm.get('tier').value;
    this.bulkOperation.dueBy = this.bulkForm.get('dueBy').value;
  }

  setFormValues() {    
     if(this.bulkOperation.quarter > 0) {
        this.bulkForm.get('quarter').setValue(this.bulkOperation.quarter);
     } 
     if(this.bulkOperation.year > 0) {
        this.bulkForm.get('year').setValue(this.bulkOperation.year);
     }
     if(this.bulkOperation.tier > 0) {
        this.bulkForm.get('tier').setValue(this.bulkOperation.tier);
     }
     if(this.bulkOperation.status != null && this.bulkOperation.status != '') {
        this.bulkForm.get('status').setValue(this.bulkOperation.status);
     }
  }


  onSubmit() {
    
      this.getFormValues();
      if(this.bulkOperation.operation == null || this.bulkOperation.operation.length == 0) {
        this.toastr.error('Operation is required');
        return;
      }

      if(this.bulkOperation.operation == 'Update' || this.bulkOperation.operation == 'Copy') {
        if(
          (this.bulkOperation.status == null || this.bulkOperation.status.length == 0) &&
          (this.bulkOperation.year == 0) &&
          (this.bulkOperation.quarter == 0) &&
          (this.bulkOperation.tier == 0) &&
          (this.bulkOperation.dueBy == null || this.bulkOperation.dueBy.length == 0)
        ) {
          this.toastr.error('All fields cannot be blank.  The Operation will not be performed.');
          return;
        }
      }

      this.sharedService.openConfirm("Are you sure you want to bulk " + this.bulkOperation.operation + " the selected retests?");
      this.sharedService.confirmed().subscribe(confirmed => {
        if (confirmed) {
          this.processing = true;
          this.retestService.bulkOperation(this.bulkOperation).subscribe(
            result => {
              this.toastr.success("Bulk Operation Completed");
              this.processing = false;
              this.dialogRef.close();
            },
            error => {
              this.processing = false;
              this.toastr.error("Unable to Delete Retests " + error.message);
            }
          );
        }
      });
  }

 
}